// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://dtslchpxweciemwvzhve.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImR0c2xjaHB4d2VjaWVtd3Z6aHZlIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTM3NjY0MDcsImV4cCI6MjA2OTM0MjQwN30.LKVQvuc1RSOgx47qA49OfbB6GUffm1Rfw1b5gcfOi14";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});